import { render, staticRenderFns } from "./bm-dash-details.vue?vue&type=template&id=b28ac190&"
import script from "./bm-dash-details.vue?vue&type=script&lang=js&"
export * from "./bm-dash-details.vue?vue&type=script&lang=js&"
import style0 from "./bm-dash-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports